module.exports = __webpack_public_path__ + "img/70100004.ef9d171d.png";